import type { MakeCall } from '../createMakeCall';
import { QualificationRequirement } from '../types/qualifications/QualificationRequirement';

const getQualificationRequirementsByListing =
  (makeCall: MakeCall) => (listingUuid: string) =>
    makeCall<QualificationRequirement>(
      'GET',
      `/api/v2/qualification/requirements/by-listing/${listingUuid}`,
    );
export { getQualificationRequirementsByListing };
